module.exports = __webpack_public_path__ + "static/media/my_fe_logo.2861f255.png";